import Input, { InputWrapper, Label } from 'components/Form/Input'
import I18n from 'components/I18n'
import { OverlayLoader } from 'components/Loaders'
import messages from 'lang'
import React, { useState } from 'react'
import styled from 'styled-components'

import DateOfBirth from './DateOfBirth'
import { Button, Header, SubTitle, Title, Wrapper } from './styles'

type Props = {
  dob?: string
  firstname?: string
  lastname?: string
  loading: boolean
  onSubmit: (firstname: string, lastname: string, dob: string) => void
}

const Names = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  margin-top: 1rem;

  > ${InputWrapper} {
    margin-top: 0;
    flex: 1;

    /* Firefox width fix */
    > input {
      width: 100%;
      box-sizing: border-box;
    }
  }
`

const PersonalInfo = ({ onSubmit, ...props }: Props) => {
  const [firstname, setFirstname] = useState(props.firstname ?? '')
  const [lastname, setLastname] = useState(props.lastname ?? '')
  const [dob, setDOB] = useState(props.dob ?? '')

  if (props.loading)
    return (
      <Wrapper>
        <OverlayLoader />
      </Wrapper>
    )

  return (
    <Wrapper>
      <Header>
        <Title>
          <I18n data={messages.title_personal_information} />
        </Title>
        <SubTitle>
          <I18n data={messages.sub_title_personal_information} />
        </SubTitle>
      </Header>
      <main>
        <Names>
          <InputWrapper>
            <Label htmlFor='kyc-firstname'>
              <I18n data={messages.label_firstname} />
            </Label>
            <Input
              name='kyc-firstname'
              onChange={(name) => setFirstname(name)}
              value={firstname}
              placeholder='Satoshi'
            />
          </InputWrapper>
          <InputWrapper>
            <Label htmlFor='kyc-lastname'>
              <I18n data={messages.label_lastname} />
            </Label>
            <Input
              name='kyc-lastname'
              onChange={(name) => setLastname(name)}
              value={lastname}
              placeholder='Nakamoto'
            />
          </InputWrapper>
        </Names>
        <DateOfBirth value={dob} onChange={setDOB} />
      </main>
      <footer>
        <Button
          disabled={!firstname || !lastname || !dob}
          onClick={() => onSubmit(firstname, lastname, dob)}
        >
          <I18n data={messages.button_continue} />
        </Button>
      </footer>
    </Wrapper>
  )
}

export default PersonalInfo
